import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchReclamationTransporteur } from 'store/reclamation/reclamationsActions';
import { fetchReclamationInfosLogistique } from 'store/reclamation/detailsActions';
import { fetchTransporteurs } from 'store/transporteur/transporteurActions';

import { fetchInfosDemandeEnlevement } from 'store/reclamation/detailsActions';
import { clearArticleGestionValue } from 'store/articleGestion/articlesGestionActions';

import DemandeEnlevementContent from './DemandeEnlevementContent';
import withLoader from 'components/Shared/withLoader';

const DemandeEnlevementContentWithLoader = withLoader(DemandeEnlevementContent);

class DemandeEnlevementContentContainer extends React.Component {

    async componentDidMount() {
        await this.props.fetchTransporteurs();
        await this.props.fetchReclamationTransporteur(this.props.reclamationId);
        await this.props.fetchReclamationInfosLogistique(this.props.reclamationId);
        await this.props.fetchInfosDemandeEnlevement(this.props.reclamationId);
        await this.props.clearArticleGestionValue();
    }
    
    render() {
        const { isLoading, onChange, action, articles, adresse, contact, transporteurInitial, clearArticleGestionValue, transporteurId, colis, transporteurs, depotDepart } = this.props;

        return (
            <DemandeEnlevementContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                articles={articles}
                adresse={adresse}
                contact={contact}
                transporteurInitial={transporteurInitial}
                clearArticleGestionValue={clearArticleGestionValue}
                transporteurId={transporteurId}
                colis={colis}
                transporteurs={transporteurs}
                depotDepart={depotDepart}
            />
        );
    }
}

DemandeEnlevementContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};


const mapStateToProps = (state, props) => {

    let isLoading = state.reclamation.details.infosDemandeEnlevement.isLoading || state.reclamation.reclamations.transporteurs.isLoading || state.transporteur.transporteurs.isLoading || state.reclamation.details.isInfosLogistiqueLoading;

    let transporteur = state.reclamation.reclamations.transporteurs.items.find(x => x.reclamationId === props.reclamationId);

    var depotDepart = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.depotDepart : '';

    return {
        isLoading: isLoading,
        transporteurId: (transporteur && transporteur.transporteurId !== -1) ? transporteur.transporteurId : '',
        transporteurs: state.transporteur.transporteurs.items,
        colis: transporteur ? transporteur.colis : [],
        depotDepart: depotDepart, 

        articles: state.reclamation.details.infosDemandeEnlevement.articles,
        adresse: state.reclamation.details.infosDemandeEnlevement.adresse,
        contact: state.reclamation.details.infosDemandeEnlevement.contact,
        transporteurInitial: state.reclamation.details.infosDemandeEnlevement.transporteurInitial,
    };
};



const mapDispatchToProps = dispatch => ({
    fetchInfosDemandeEnlevement: (reclamationId) => dispatch(fetchInfosDemandeEnlevement(reclamationId)),
    clearArticleGestionValue: () => dispatch(clearArticleGestionValue('addAction')),

    fetchTransporteurs: () => dispatch(fetchTransporteurs()),
    fetchReclamationTransporteur: (reclamationId) => dispatch(fetchReclamationTransporteur(reclamationId)),
    fetchReclamationInfosLogistique: (reclamationId) => dispatch(fetchReclamationInfosLogistique(reclamationId)),

});



export default connect(mapStateToProps, mapDispatchToProps)(DemandeEnlevementContentContainer);